import PageLinks from "@/components/common/PageLinks";
import Preloader from "@/components/common/Preloader";
import Settings from "@/components/dashboard/Settings/Settings";

import FooterOne from "@/components/layout/footers/FooterOne";
import Header from "@/components/layout/headers/Header";
import React from "react";

import MetaComponent from "@/components/common/MetaComponent";

const metadata = {
  title:
    "User-settings || GVK EDU – Premier Pharmacy Exam Coaching & Comprehensive Study Resources Since 2014",
  description:
    "Elevate your e-learning content with Educrat, the most impressive LMS template for online courses, education and LMS platforms.",
};

export default function UserSettingsPage() {
  
  return (
    <div className="main-content  ">
      <MetaComponent meta={metadata} />
      <Preloader />
      <div className="content-wrapper  js-content-wrapper overflow-hidden">
          <Settings />
        <FooterOne />
      </div>
    </div>
  );
}
